import ExcelJS from "exceljs";
import dayjs from "dayjs";

const HEADER_BLUE = "FF081E56";
const ALTERNATE_ROW_BLUE = "FFF4F8FD";
const WHITE = "FFFFFFFF";
const BORDER_GREY = "FFD0D5DD";

export const buildPlanTypeMappingsWorkbook = (mappings = []) => {
  const workbook = new ExcelJS.Workbook();
  workbook.creator = "Rosemount Staff Portal";
  workbook.created = new Date();
  workbook.modified = new Date();

  const worksheet = workbook.addWorksheet("IO Plan Type Mapping", {
    views: [{ state: "frozen", ySplit: 1, showGridLines: false }],
  });

  worksheet.columns = [
    { header: "IO Plan Type Name", key: "planTypeName", width: 38 },
    { header: "Rosemount Category", key: "planCategory", width: 30 },
    { header: "IO Plan Type ID", key: "planTypeId", width: 24 },
    { header: "IO Portfolio Category", key: "portfolioCategory", width: 30 },
    { header: "IO Product Group", key: "productGroup", width: 30 },
  ];

  mappings.forEach((mapping) => {
    worksheet.addRow({
      planTypeName: mapping.planTypeName || "",
      planCategory: mapping.planCategory || "",
      planTypeId: mapping.planTypeId || "",
      portfolioCategory: mapping.portfolioCategory || "",
      productGroup: mapping.productGroup || "",
    });
  });

  worksheet.autoFilter = { from: "A1", to: "E1" };
  worksheet.properties.defaultRowHeight = 20;

  const header = worksheet.getRow(1);
  header.height = 30;
  header.eachCell((cell) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: HEADER_BLUE },
    };
    cell.font = { bold: true, color: { argb: WHITE } };
    cell.alignment = { vertical: "middle", horizontal: "left", wrapText: true };
  });

  worksheet.eachRow((row, rowNumber) => {
    row.eachCell((cell) => {
      cell.border = {
        bottom: { style: "thin", color: { argb: BORDER_GREY } },
      };
      cell.alignment = { vertical: "top", wrapText: true };
      if (rowNumber > 1 && rowNumber % 2 === 0) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: ALTERNATE_ROW_BLUE },
        };
      }
    });
  });

  return workbook;
};

export const downloadPlanTypeMappingsExcel = async (mappings = []) => {
  const workbook = buildPlanTypeMappingsWorkbook(mappings);
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `IO-Plan-Type-Mapping-${dayjs().format("YYYY-MM-DD")}.xlsx`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
